import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import { AriaRoles } from '../../../../constants/AccessibilityConstants';
import { createBEM } from '../../../../lib/utils/css';
import Img from '../../../ImageLoader/ImageLoader';

import RowItemRings from './RowItemRings';

import './RowItemImage.scss';

class RowItemImage extends React.PureComponent {
  static propTypes = {
    dominantColor: PropTypes.string,
    imgUrl: PropTypes.string,
    isImgCircle: PropTypes.bool,
    isLarge: PropTypes.bool,
    isRowSmall: PropTypes.bool,
    isStation: PropTypes.bool,
    mainText: PropTypes.string,
    mainTextOnclick: PropTypes.func,
    mainTextUrl: PropTypes.string,
    qaImg: PropTypes.string,
    shouldLinkImg: PropTypes.bool,
  };

  renderImg = () => {
    const bgColor = this.props.dominantColor && `#${this.props.dominantColor}`;

    return (
      <Img
        src={this.props.imgUrl}
        isCircle={this.props.isImgCircle}
        hasShadow={false}
        doesFade={false}
        hasBorder={true}
        role={AriaRoles.PRESENTATION}
        alt={this.props.mainText}
        qaTag={this.props.qaImg}
        bgColor={bgColor}
      />
    );
  };

  shouldRender = () => this.props.imgUrl && !this.props.isRowSmall;

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    const classes = createBEM('RowItemImage', {
      circle: this.props.isImgCircle,
      large: this.props.isLarge,
    });

    if (this.props.shouldLinkImg && (this.props.mainTextUrl || this.props.mainTextOnclick)) {
      const props = {
        to: this.props.mainTextUrl,
        onClick: this.props.mainTextOnclick,
        tabIndex: '-1',
      };

      return (
        <div className={classes}>
          <Link {...props}>{this.renderImg()}</Link>
        </div>
      );
    }

    return (
      <div className={classes}>
        {this.renderImg()}
        {this.props.isStation && <RowItemRings />}
      </div>
    );
  }
}

export default RowItemImage;
